export const PROJECT_FETCHING_ERROR_PREFIX = 'Failed to fetch project by id';
